import { PipeTransform } from '@angular/core'
import { Pipe } from '@angular/core'
import { NamedDate } from '../models/namedDate'
import { isSameDay, format } from 'date-fns'
import { dateOnlyFormat } from '../utilities/date' 
import { TZDate } from '@date-fns/tz'

@Pipe({
  name: 'maskedDate',
  pure: true,
})
export class MaskedDatePipe implements PipeTransform {
  transform(
    value: Date | string | undefined | null,
    masks?: NamedDate[],
    _format?: string,
    _viewAsTZ?: string,
  ): string | null {
    const foundMask = masks?.find((m) => value && isSameDay(value, m.value()))
    return (
      foundMask?.name ??
      (value ? format(new TZDate(value as Date, _viewAsTZ ?? 'EST'), _format ?? dateOnlyFormat) : '-')
    )
  }
}
